'use strict';

module.exports = require('./ckeditor');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-ckeditor-component/lib/index.js
 ** module id = 381
 ** module chunks = 0
 **/